export const iPadDown = "@media (max-width: 1079px)";
export const iPadUp = "@media (min-width: 1080px)";
